import { ACMeterPacket } from './packet-meter-ac';
import { DCMeterPacket } from './packet-meter-dc';
import { USBMeterPacket } from './packet-meter-usb';
import { ReplyPacket } from './packet-reply';
export function readPacket(block) {
    const type = block.readUInt8(0x02);
    if (type === 1 /* Report */) {
        switch (block.readUInt8(0x03)) {
            case 0x01:
                return new ACMeterPacket(block);
            case 0x02:
                return new DCMeterPacket(block);
            case 0x03:
                return new USBMeterPacket(block);
        }
    }
    else if (type === 2 /* Reply */) {
        return new ReplyPacket(block);
    }
    return;
}
export function isMeterPacket(packet) {
    return packet instanceof ACMeterPacket || packet instanceof DCMeterPacket || packet instanceof USBMeterPacket;
}
export function readUInt24BE(block, offset) {
    return (block.readInt8(offset) << 16) + block.readUInt16BE(offset + 1);
}
export function readDuration(block, offset) {
    const values = [
        String(block.readUInt16BE(offset)).padStart(3, '0'),
        String(block.readUInt8(offset + 2)).padStart(2, '0'),
        String(block.readUInt8(offset + 3)).padStart(2, '0'),
    ];
    return values.join(':');
}
export function makeChecksum(block) {
    const checksum = block.reduce((acc, value) => (acc + value) & 0xff);
    return Buffer.of(checksum ^ 0x44);
}
